// 俄语
// cSpell:disable
export const h = {
  case: {
    title: "Настройка информации о случае",
    name: "Наименование",
    coverImage: "изображение обложки",
    describe: "описание",
    uploadDesc:
      "Нажмите, чтобы загрузить изображение, рекомендуемый размер (500 * 375)",
    shareLink: "Поделиться настройками ссылки",
    expiration: "Никогда не истекает",
    on: "ВКЛ",
    off: "ВЫКЛ",
    failureTime: "время отказа",
    pickDay: "Пожалуйста, выберите дату",
    pickerOptions: {
      shortcuts: [
        {
          text: "1 день спустя",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            return date;
          },
        },
        {
          text: "1 неделя спустя",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            return date;
          },
        },
        {
          text: "30 дней спустя",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            return date;
          },
        },
      ],
    },
    dateCannotEmpty: "Дата не может быть пустой",
    nameCannotEmpty: "Имя не может быть пустым!",
    descCannotEmpty: "Описание не может быть пустым!",
    logoSet: "Настройки логотипа",
    selectAll: "Выбрать все",
    noBrand: "Пока нет бренда",
    openEffect: "Эффект открытия",
    closeOpenMode: "Нет",
    asteroidOpen: "Открытие астероидов",
    horizontalOpen: "Открытие горизонтального круиза",
    asteroidCruise: "Открытие круиза астероидов",
    Crystal: "Открытие хрустального шара",
    asteroidScale: "Asteroid Zoom Открытие",
    limitImage:
      "Размер изображения слишком велик, пожалуйста, ограничите размер изображения не более 4M",
    imageType:
      "Неправильный тип изображения, пожалуйста, загрузите изображения в формате png, jpg",
  },
  slide: {
    case: "Случай",
    save: "сохранить",
    view: "просмотреть",
    panorama: "Панорама",
    angleView: "угол зрения",
    hotspot: "Горячая точка",
    music: "музыкальный",
    designer: "Дизайнер",
    beautify: "украшение",
  },
  list: {
    title: "Настройки списка панорамы",
    draganoramicsort: "Перетащите панораму для сортировки",
    resetSort: "Сброс",
    addPanoramic: "Добавление",
    customThumbnailImages: "Пользовательские миниатюры",
    more: "Больше",
    downloadImage: "Скачать панорамные изображения",
    replaceImage: "Замена панорамного изображения",
    downloadImagePackage: "Скачать пакет панорамы",
    downloadDiagram: "Скачать диаграмму каналов",
    ApplyThumbnailToImage: "Применить эту миниатюру к обложке корпуса",
    VoiceBroadcast: "сообщение голосовой трансляции",
    restoreImage: "Восстановить панорамное изображение",
    uploadImage: "Нажмите, чтобы загрузить изображение",
    upgradePackage: "Пакет обновления",
    eidt: "Модификация панорамы",
    name: "Название панорамы",
    thumbnail: "миниатюры",
    enterName: "Введите имя панорамы",
    uploadDesc:
      "Нажмите, чтобы загрузить изображение, рекомендуемый размер (500 * 375)",
    confirm: "определить",
    cannotEmpty: "Название панорамы не может быть пустым",
    selectToAdd: "Выберите панораму Добавить",
    selectAll: "Выбрать все эту страницу",
    StartAndEnd: "время начала и окончания",
    schemeName: "Название схемы рендеринга",
    清晰度: 'четкость',
    searchThisPlan: "Запрос по данной схеме",
    search: "Запросы",
    empty: "В текущий промежуток времени нет рендеринговых сцен",
    dateOptions: {
      shortcuts: [
        {
          text: "сегодня",
          value() {
            const end = new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            );
            const start = new Date(
              new Date(new Date().toLocaleDateString()).getTime()
            );
            return [start, end];
          },
        },
        {
          text: "3 дня назад",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            return [start, end];
          },
        },
        {
          text: "1 неделю назад",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: "30 дней назад",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "90 дней назад",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
      ],
    },
    loading: "Загрузка...",
    sceneAlreadyExists: "Эта сцена уже существует в текущем списке панорамы",
    previewImage:
      "Текущая панорама представляет собой быстрый предварительный просмотр",
    applyToThumbnail: "Применить к миниатюрам",
    delete: "Удалить",
    content:
      "Удаление этой сцены удалит горячие точки, указывающие на сцену в других сценах. Продолжить удаление?",
    captureScreen: "Снимок экрана",
    generateScreenshots: "Сгенерировать скриншот",
    thumbnailApply:
      "Применение миниатюр успешно, вступает в силу после сохранения",
    atLeastOne: "Пожалуйста, сохраните хотя бы одну сцену~",
    downloadCompleted: "Загрузка завершена!",
    fielDownloadFailed: "Не удалось загрузить файл!",
    limitImageSize:
      "Размер изображения слишком большой, пожалуйста, ограничите размер изображения не более",
    imageType:
      "Неправильный тип изображения, пожалуйста, загрузите изображения в формате png, jpg",
    imageAspectRatio: "Пожалуйста, загрузите соотношение сторон как",
    replaceFailed: "Замена не удалась, пожалуйста, попробуйте снова",
    uploadFailed: "Не удалось загрузить, пожалуйста, попробуйте снова",
    restoreFailed: "Восстановление не удалось",
    applySuccess: "Применение успешно, вступает в силу после сохранения",
    dateCannotEmpty: "Дата не может быть пустой",
    全部: "Все",
    快速预览: "быстрый предварительный просмотр",
  },
  camera: {
    rotationSettings: "Настройка поворота",
    turnOnRotation: "включить вращение",
    waitTime: "Время ожидания (секунд)",
    clickSettings: "настройки",
    rotationInfoBefore:
      "Вы подтверждаете, что текущее состояние вращения применяется к текущему списку сцен",
    rotationInfoAfter: "Сцена и сохранить?",
    cameraSettings: "Линзы",
    recently: "Ближайший: минимальное поле обзора при масштабировании сцены",
    initial: "Начальный: введите начальное поле зрения сцены",
    farthest: "Дальнейшее: максимальное поле обзора при масштабировании сцены",
    recommended:
      "Рекомендуемые настройки: ближайший 70, начальный 95, дальний 125",
    viewingAngle: "диапазон углов обзора",
    recentlyt: "в последнее время",
    initialt: "начальный",
    farthestt: "самый дальний",
    viewInfoFirst:
      "Вы подтверждаете, что текущий диапазон поля зрения (недавно:",
    viewInfoSecend: ") применяется к текущему списку сцен",
    viewInfoThird: "Сцена и сохранить?",
    inCommonUse: "Общий",
    reset: "снижение",
    stapleInfo:
      "Сохранить текущий диапазон углов обзора как мои обычные объективы",
    commonLenses: "Часто используемые линзы",
    systemLens: "Системный объектив",
    restoreInfo:
      "Восстановить начальное значение диапазона поля зрения текущей сцены",
    restoreDefault: "Восстановление по умолчанию успешно",
    recommendedLens:
      "Использование рекомендуемого объектива успешно, вступает в силу после сохранения",
    usedLenses: "Используйте обычные объективы успешно и вступите в силу после",
    initialViewpoint:
      "Начальный угол обзора успешно установлен и вступит в силу после сохранения",
    setCommonLens: "Настройка часто используемых объективов успешно",
    initialPerspective: "Установить как начальный угол зрения",
  },
  hotspot: {
    addHotspots: "Добавление",
    clear: "Очист.",
    clearHotspots: "Опустить горячую точку",
    clearHotspotsForCurrentScene: "Очистить список горячих точек текущей сцены",
    editHotspots: "Редактировать горячую точку",
    return: "Назад",
    hotspotType: "Типы горячих точек",
    type: "Тип",
    hotspotList: "Список горячих точек текущей сцены",
    all: "Все",
    navigation: "Навигация",
    link: "гиперссылка",
    image: "фотографии",
    deleteHotspot: "Подтвердить удаление этой точки доступа",
    style: "стиль",
    hotspotName: "Название горячей точки",
    name: "Наименование",
    enterHotspotName: "Пожалуйста, введите имя горячей точки",
    targetPanorama: "целевая панорама",
    ok: "Да",
    cancel: "Нет",
    edit: "модификация",
    delete: "Удалить",
    confirmDelete: "Подтвердить удаление этой точки доступа",
    hotspotImage: "Горячие фотографии",
    uploadImage: "Нажмите, чтобы загрузить изображение",
    editImage: "Изменить картинку",
    addImage: "Добавить картинку",
    hotspotAddress: "Адрес горячей точки",
    address: "Адрес",
    targetUrl: "Пожалуйста, введите адрес цели",
    videoAddress: "Адрес видео",
    videoUrl: "Пожалуйста, введите URL видео",
    targetNoEmpty: "Целевая сцена не может быть пустой",
    noTarget: "Целевая сцена пока нет",
    hotspotNameNoEmpty: "Имя горячей точки не может быть пустым",
    hotspotDetailNoEmpty: "Детали горячей точки не могут быть пустыми",
    linkNoEmpty: "Адрес ссылки не может быть пустым",
    linkIncorrect: "Неправильный формат адреса ссылки",
    videoNoEmpty: "Адрес видеосвязи не может быть пустым",
    pleaseUploadImage: "Пожалуйста, сначала загрузите фотографии горячих точек",
    limitImage:
      "Размер изображения слишком велик, пожалуйста, ограничите размер изображения не более 30M",
    uploadFailed: "Не удалось загрузить, пожалуйста, попробуйте снова",
    uploadSuccessful: "Загрузка успешна",
    imageType:
      "Неправильный тип изображения, пожалуйста, загрузите изображения в формате png, jpg",
    noHotSpots: "В текущей сцене нет горячих точек",
    text: "Текст",
    video: "Видео",
    hotspotDetail: "Подробности горячих точек",
    detail: "Подробности",
    noOtherScene: "Других сцен пока нет",
    enterHotspotDetail: "Пожалуйста, введите детали горячей",
    videoResources: "Видеоресурсы",
    clickToSwitch: "Нажмите для переключения",
    clickUploadVideo: "Нажмите, чтобы загрузить видео",
    videoFormat: "Поддержка формата MP4, максимум не более 100M",
    enerVideoUrl: "Пожалуйста, введите URL видео",
  },
  music: {
    musicSettings: "Настройки музыки",
    trialListening: "прослушивание",
    stopListening: "остановить прослушивание",
    setMusic: "Настройка музыки",
    backgroundMusic: "фоновая музыка",
    SystemMusicLibrary: "Системная медиатека",
    selected: "Выбранный",
    myMusic: "Моя музыка",
    uploadMusic: "Загрузить музыку",
    upgradePackage: "Пакет обновления",
    uploadAgree: "Загрузите и согласитесь",
    disclaimer:
      "Пожалуйста, сначала поставьте галочку отказ от ответственности",
    musicName: "Пожалуйста, введите имя музыки",
    deleteMusic: "Удалить музыку",
    noCustomMusic: "Пока нет пользовательской музыки",
    onlineMusic: "Онлайн музыка",
    operationProcess: "Эксплуатационный процесс",
    oneStep:
      "Найдите правильную аудиоссылку, введите аудиоссылку в поле ввода браузера, если она может быть воспроизведена или загружена, это, как правило, правильная аудиоссылка;",
    twoStep: "Вставьте аудиоссылку в поле ввода выше;",
    threeStep:
      "Сначала нажмите кнопку OK, а затем нажмите в верхнем левом углу для сохранения.",
    ok: "определить",
    placeholderInfo:
      "Введите музыкальный адрес в Интернете и гарантируйте наличие музыки",
    musicAddress: "Пожалуйста, введите адрес музыки",
    limitMusic:
      "Музыкальный адрес слишком длинный, пожалуйста, ограничьте длину адреса до 150 символов",
    saveMusic: "Пожалуйста, выберите музыку перед сохранением",
    linkIncorrect: "Неправильный формат адреса ссылки",
    musicNonEmpty: "Название музыки не может быть пустым",
    eidtFailed: "Ошибка модификации",
    deleteSuccess: "Удаление успешно",
    deleteFailed: "Удаление не удалось",
    limitNameCharacter:
      "Имя файла превышает 50 символов, пожалуйста, измените его перед загрузкой",
    limitFileSize:
      "Файл слишком большой, пожалуйста, ограничите файл не более 10M",
    limitFileType:
      "Неправильный формат файла, пожалуйста, загрузите файл в формате mp3 или wav",
    limitFileNumber:
      "Слишком много файлов, максимальное ограничение загрузки 30 файлов",
    uploadFailed: "Не удалось загрузить, пожалуйста, попробуйте снова",
    uploadSuccessful: "Загрузка успешна",
    disclaimerInfo: "Отказ от ответственности",
  },
  design: {
    designerInfo: "Информация для дизайнеров",
    name: "Имя и имя",
    enterName: "Введите имя",
    phone: "Телефон",
    enterPhone: "Введите телефон",
    avater: "аватар",
    uploadImageInfo:
      "Нажмите, чтобы загрузить изображение, рекомендуемый размер (64 * 64)",
    nameNonEmpty: "Имя не может быть пустым!",
    phoneNonEmpty: "Телефон не может быть пустым!",
    phoneNumber: "Пожалуйста, введите правильный номер телефона!",
    limitImage:
      "Размер изображения слишком велик, пожалуйста, ограничите размер изображения не более 4M",
    imageType:
      "Неправильный тип изображения, пожалуйста, загрузите изображения в формате png, jpg",
  },
  beauty: {
    filterSet: "Настройки фильтра",
    colorSet: "Цветовые настройки",
    brightness: "яркость",
    contrastRatio: "контрастная степень",
    saturation: "насыщенность",
    hue: "оттенок",
    restoreDefault: "по умолчанию",
    compareOriginalImage: "сравнить оригинальное изображение",
    originalImage: "Удерживая нажатие, чтобы показать оригинальное изображение",
    noFilter: "Без фильтра",
    warmYellow: "Cálido",
    romanticPurple: "Ром.Фиол",
    modernGrey: "серый",
    restoreSuccessful: "Восстановление по умолчанию успешно",
  },
  tipInfo: {
    tip: "подсказка",
    switchNavigation: "Переходить навигацию",
    fillCorrectly: "Пожалуйста, после правильного заполнения",
    panoramaEditor: "Редактор панорамы",
    editSave: "Пожалуйста, отредактируйте и",
    viewSave:
      "У вас есть несохраненная информация, пожалуйста, сначала сохраните ее, а затем просмотрите ее",
    saveView: "Сохранить просмотр",
    save: "Сохраняется",
    saveSuccess: "Сохранение успешно",
    请填写必填项后再进行编辑: "Пожалуйста, заполните обязательные поля перед редактированием"
  },
  loading: {
    schemeLoading: "Схема загружается...",
    loadingTitle:
      "Стремясь быть лучшей интегрированной платформой дизайна дома",
    loadingStrives: "Тяньгун Чжицзя приложил все усилия для создания",
  },
  driver: {
    案例详情: "Подробности дела",
    修改全景名称描述等:
      "Изменить название панорамы, описание и т. Д., Установить время истечения срока действия панорамы, контролировать отображение логотипа бренда и т. Д.",
    下一步: "Следующий шаг",
    上一步: "Предыдущий шаг",
    关闭: "закрытие",
    完成: "Завершить",
    全景列表: "Список панорамы",
    增加删除修改场景:
      "Добавлять, удалять, изменять сцены, загружать панорамные изображения, заменять миниатюры панорамы, изменять имена панорамы и т. Д.",
    视角设置: "Настройка угла обзора",
    设置全景是否开启自动旋转:
      "Установите, включено ли автоматическое вращение панорамы; Информация о первоначальном угле обзора панорамы и т.д.",
    热点设置: "Настройки горячей точки",
    增加新的热点或修改已有热点:
      "Добавьте новые горячие точки или измените существующие.",
    设置音乐: "Настройка музыки",
    设计师信息设置: "Настройки информации дизайнера",
    设置设计师头像姓名:
      "Установите аватар дизайнера, имя, контактную информацию и другую информацию.",
    美化设置: "Настройки благоустройства",
    设置全景滤镜效果:
      "установить эффект панорамного фильтра; Изменение панорамной яркости цвета, контрастности, оттенка и т. Д.",
  },
  video: {
    视频转换: "Преобразование видео",
    上传视频: "Загрузить видео",
    视频格式错误请重新上传视频将转码转码时无法使用全景其他功能:
      "Неверный формат видео, пожалуйста, загрузите его повторно. Видео будет транскодировано, при транскодировании нельзя использовать другие функции панорамы.",
    支持MP4格式最大不超过300M: "Поддержка формата MP4, максимум не более 300M",
    上传视频编码错误请重新上传:
      "Ошибка кодирования загруженного видео, пожалуйста, загрузите его снова",
    视频转换中: "В процессе преобразования видео",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/lan/ru.js